const dataMigrations = [
  {
    title: 'Data Migration',
    icon: 'UploadIcon',
    enableFeature: true,
    children: [
      {
        title: 'Loan Account',
        route: 'loan-account',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'GL Creation',
        route: 'gl-creation',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'GL Balance',
        route: 'gl-balance',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'Customer Balance',
        route: 'customer-balance',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'Loan Schedule',
        route: 'loan-schedule',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'Overdraft Account',
        route: 'overdraft-account',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'Fixed Deposit Account',
        route: 'fixed-deposit-account',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'Individual Customer Creation',
        route: 'individual-customer-creation',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'Group Member Mapping',
        route: 'group-member-mapping',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'Group Customer Creation',
        route: 'group-customer-creation',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
      {
        title: 'Corporate Customer Creation',
        route: 'corporate-customer-creation',
        hasPermission: 'DATA_MIGRATION',
        enableFeature: true,
      },
    ],
  },
]

export default dataMigrations
